import { BaseModel } from "sjs-base-model";

export default class ProvviggioneAgenteBase extends BaseModel {
    public readonly percentuale: number = 0;
    public readonly importo: number = 0;
    public readonly descrizione: null | string = null;
    constructor(data: Partial<ProvviggioneAgenteBase>) {
        super();

        this.update(data);
    }
}
